
<template>
  <div>
    <v-card flat style="border: solid 0px #ccc">
      <v-card-text class="pt-0">
        
        <div v-for="(item, idx) in order.items_attributes" :key="item.ref+idx">
          <ProductsOneItem 
            :can_delete="order.items_attributes.length > 1" 
            style="border: 1px solid #ccc; border-radius: 8px" 
            class="my-3" 
            :item="item" 
            :idx="idx" 
            :order="order"
            @clientLastOrder="$emit('clientLastOrder')"
            @removeItem="handleRemoveItem(idx)"
          ></ProductsOneItem>
        </div>
        <v-container class="d-flex justify-center">
          <v-btn color="primary" small @click="$emit('addItem')"> <v-icon left>mdi-plus</v-icon> Produto </v-btn>
        </v-container>
        
      </v-card-text>
    </v-card>
  </div>
</template>

<script>

export default {
  name: 'ProductAndPrices',
  components: {
    ProductsOneItem: () => import('./ProductsOneItem.vue'),
  },
  props: {
    order: {
      type: Object,
      default: {}
    },
  },
  methods: {
    handleRemoveItem(idx) {
      if (idx != null && idx != undefined) {
        this.order.items_attributes.splice(idx, 1)
      }
    },
  },
}
</script>